
<div ref="defineTab">
  <panel-block v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.labelable)" id="pn-label">
    <panel-item>
      <label :for="selectedObjectModelProperty.idForProp('label')">Label</label>
      <expandable-textarea
        :id="selectedObjectModelProperty.idForProp('label')"
        v-model="selectedObjectModelProperty.label_title"
        placeholder="Enter a label..."></expandable-textarea>
    </panel-item>
  </panel-block>

  <aggregatable-config
    @input="onAggregateSelection"
    v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.aggregatable)"
    id="aggregatable-config"
    :model="selectedObjectModelProperty"
  >
  </aggregatable-config>
  <panel-block v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.linkToRelationable)" id="pn-linked-relationship">
    <panel-item>
      <label :for="selectedObjectModelProperty.idForProp('linked_relation_client_id')" class="a-select-label">Relationship</label>
      <config-field-validation :model="selectedObjectModelProperty" field-name="linked_relation_client_id">
        <a-select
          :id="selectedObjectModelProperty.idForProp('linked_relation_client_id')"
          :options="relationSearchOptions"
          compress
          force-nullify-if-null
          bind-by-object
          :value="getRelationOption()"
          @input="setRelationOption"
        ></a-select>
      </config-field-validation>
    </panel-item>
    <template v-for="relationObjectModel in linkedObjectModels">
      <template v-if="showConfigureMappedProperty">
        <label
          :for="relationObjectModel.idForProp('linked_relation_mapped_properties')"
          class="a-select-label">
          {{`${relationObjectModel.title}'s Mapped Property`}}
        </label>
        <config-field-validation :model="selectedObjectModelProperty" :field-name="relationObjectModel.idForProp('linked_relation_mapped_properties')">
          <a-select
            :id="relationObjectModel.idForProp('linked_relation_mapped_properties')"
            @input="addLinkedPropertyRelation($event, relationObjectModel)"
            :options="objectModelPropertyWithDefaultVOptionSetsFor(relationObjectModel)"
            compress
            bind-by-object
            force-nullify-if-null
            :value="mappedPropertyValue(relationObjectModel)"
          ></a-select>
        </config-field-validation>
      </template>
      <panel-item  v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.aggregatable) && linkedRelationMappedProperty(relationObjectModel)">
        <label
          :for="relationObjectModel.idForProp('linked_relation_has_filter')"
          class="a-select-label">
          Do you want to add a filter?
        </label>
        <yes-no-select :id="relationObjectModel.idForProp('linked_relation_has_filter')"
                       compress
                       v-model="linkedRelationMappedProperty(relationObjectModel).linked_property_has_filter"
                       :value="aggregatePropertyHasFilter(relationObjectModel)"></yes-no-select>
        <panel-item v-if="aggregatePropertyHasFilter(relationObjectModel)">
          <conditional-wrapper
            :parent="linkedRelationMappedProperty(relationObjectModel)"
            :field-definition="ObjectModelConditionalFields.AGGREGATE_FILTER"
            :has-otherwise-value="false"
            :conditional-rule-options="conditionalRuleOptions"
            :can-add-rule="Object.keys(linkedRelationMappedProperty(relationObjectModel).filter_conditional_rule_sets).length === 0">
            <template #value="slotProps">
              <input type="hidden"
                     v-model="slotProps.model[slotProps.fieldName]"
                     value="true">
            </template>
          </conditional-wrapper>
        </panel-item>
      </panel-item>
      <panel-item v-if="displayNullOptions">
        <label
          :for="selectedObjectModelProperty.idForProp('linked_relation_has_null_value')"
          class="a-select-label">
          Ignore NULL Values?
        </label>
        <yes-no-select :id="selectedObjectModelProperty.idForProp('linked_relation_has_null_value')"
                       compress
                       v-model="selectedObjectModelProperty.linked_property_has_null_value"
                       :value="selectedObjectModelProperty.linked_property_has_null_value"></yes-no-select>

        <panel-item v-if="!selectedObjectModelProperty.linked_property_has_null_value">
          <label
            :for="selectedObjectModelProperty.idForProp('no_null_value')"
            class="a-select-label">
            Convert NULL Values to
          </label>
          <NumberInput
            :id="selectedObjectModelProperty.idForProp('no_null_value')"
            v-model="selectedObjectModelProperty.null_replacement_value">
          </NumberInput>
        </panel-item>
      </panel-item>
      <panel-item v-if="showAggregateNullLabelTitle">
        <label
          :for="selectedObjectModelProperty.idForProp('null_value')"
          class="a-select-label">
          {{ aggregateNullLabelTitle }}
        </label>
        <a-select
          :id="selectedObjectModelProperty.idForProp('null_value')"
          :options="optionsForNullValue"
          compress
          v-model="selectedObjectModelProperty.null_value"
        ></a-select>
      </panel-item>
    </template>

  </panel-block>

</div>
